import React, { useEffect, useState } from "react";
import { useMediaQuery } from 'react-responsive';
import TalentHeader from "../../components/TalentHeader";
import TalentSideMenu from "../../components/TalentSideMenu";
import CustomCarousel from "../../components/CustomCarousel";
import CustomButton from "../../components/CustomButton";
import TextInput from "../../components/TextInput";
import JobCard from "./components/JobCard";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import CustomPagination from "../../components/CustomPagination";
import { formatDate, trimStringFields} from "../../utils/format";
import InfiniteScroll from "react-infinite-scroll-component";
import { LoadingIcon } from "../../components/Icons";
import { useNavigate } from "react-router-dom";
import ConsultingButton from "../../components/ConsultingButton";
import CustomToast from "../../components/CustomToast";
import { useSnackbar } from "notistack";
import {
  setChatSelected,
  setIsChatting, setIsNewChatFormOtherScreen,
  setIsScout,
  setJobSelected, setMessages,
  setStaffSelected,
  setIsLoadNewListChat,
} from "reducers/chatMessage";
import {
    getTalentJobList,
    setCurrentPage,
    getSuitableJob,
    setSearchQuery,
    setPageStatus,
    getTalentJobListMobile,
    setCurrentPageLoading,
    setHasMore,
    setSuccess,
    setError,
    setIsReloadJobList,
    getSuitableJobFull,
    setSuitableJobFull,
    setIsMobileScreen,
    setSuitableJobCurrentPage
} from "../../reducers/talentJob";
import ReturnButton from "../../components/ReturnButton";
import Copyright from "../../components/Copyright";
import { MOBILE_SCREEN_WIDTH } from "../../constants/index";

const TalentJob = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const {chatList} = useSelector((state: any) => state.chatMessage);
    const [isReload, setIsReload] = useState(false);
    const [isMoreSuitable, setIsMoreSuitable] = useState(false);
    const [suitableJobCurrentPagePC, setSuitableJobCurrentPagePC] = useState(1);
    const currentUser = useSelector((state: any) => state.currentUser);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const isMobile = useMediaQuery({ maxWidth: MOBILE_SCREEN_WIDTH });
    const {
        success,
        error,
        actionName,
        searchQuery,
        currentPage,
        countItems,
        pageSize,
        jobList,
        suitableJob,
        totalResults,
        pageStatus,
        jobListMobile,
        pageSizeLoading,
        currentPageLoading,
        totalResultsMobile,
        hasMore,
        isReloadJobList,
        suitableJobFull,
        suitableJobPC,
        suitableJobTotalResults,
        isMobileScreen,
        isSuitableJobFullHasMore, suitableJobCurrentPage, maxSuitableJobSlide, minItemsDisplayed
    } = useSelector((state: any) => state.talentJob);

    const fetchJob = (page=currentPage, search=searchQuery) => {
        let data = {
            page: page,
            pageSize: pageSize,
            search: search,
        };
        data = trimStringFields(data);
        dispatch(getTalentJobList(data));
        dispatch(setCurrentPage(page));
    }

    const fetchSuitableJob = (page: any) => {
        dispatch(setIsMobileScreen(true));
        let currentPage = 1
        if (!page) {
            currentPage = suitableJobCurrentPage + 1
        } else {
            currentPage = page
        }
        const data = {
            page: currentPage,
            pageSize: pageSize,
            minItems: minItemsDisplayed,
        };
        dispatch(getSuitableJobFull(data));
        dispatch(setSuitableJobCurrentPage(currentPage));
    }
    
    const fetchSuitableJobPC = (page: any) => {
        const data = {
            page: page,
            pageSize: pageSize,
            minItems: minItemsDisplayed,
        };
        dispatch(getSuitableJobFull(data));
    }

    useEffect(() => {
        const data = {
            minItems: minItemsDisplayed,
            limit: maxSuitableJobSlide,
        }
        dispatch(getSuitableJob(data));
    }, []);

    useEffect(() => {
        if (!isMobile) {
            fetchJob();
            fetchSuitableJobPC(1)
        }
    }, [isMobile, isReloadJobList]);

    useEffect(() => {
        if (isMobile) {
            fetchJobMobile();
            fetchSuitableJob(1);
        }
        return () => {
            dispatch(setCurrentPageLoading(1));
        }
    }, [isMobile, isReloadJobList]);

    useEffect(() => {
        if(success && actionName == "setJobCardBookmark"){
            showToast('メッセージ', success, "success");
            dispatch(setSuccess(null));
        }
        else if(error && actionName == "setJobCardBookmark"){
            showToast('メッセージ', error, "error");
            dispatch(setError(null));
        }
    }, [error, success]);

    const handleJobSearch = (e: any) => {
        handleSetPageStatus("searching");
        const page = 1;
        fetchJob(page);
        dispatch(setCurrentPageLoading(page));
    };

    const handleSetPageStatus = (status: string) => {
        dispatch(setPageStatus(status));
    }

    const suitableJobMore = (status: string) => {
        dispatch(setPageStatus(status));
        dispatch(setIsMobileScreen(true));
    }

    const suitableJobPCMore = (status: string) => {
        dispatch(setIsMobileScreen(false));
        setSuitableJobCurrentPagePC(1);
        setIsMoreSuitable(!isMoreSuitable)
        fetchSuitableJobPC(1)
    }

    const handleSetSearchQuery = (keyword: string) => {
        dispatch(setSearchQuery(keyword));
    }

    const handleClearSearch = () => {
        handleSetSearchQuery("");
        fetchJob(1, "");
    }

    const carouselList = suitableJob.map((item: any, idx: number) => (
        <JobCard items={item} key={idx} />
    ));

    const handleChangePage = (pageNumber: any) => {
        dispatch(setCurrentPage(pageNumber));
        fetchJob(pageNumber);
    };

    const handleChangePageSuitable = (pageNumber: any) => {
        setSuitableJobCurrentPagePC(pageNumber);
        fetchSuitableJobPC(pageNumber)
    };

    const handleJobSearchAll = () => {
        dispatch(setHasMore(true));
        handleSetPageStatus("searching");
        const page = 1;
        fetchJob(page);
        fetchJobMobile(page);
    }

    /* Action with mobile */
    const fetchJobMobile = (page=currentPageLoading, search=searchQuery) => {
        const data = {
            search: search,
            page: page,
            pageSize: pageSizeLoading,
        };
        dispatch(getTalentJobListMobile(data));
        dispatch(setCurrentPageLoading(page));
    }

    const fetchData = () => {
        fetchJobMobile(currentPageLoading+1);
    }

    const handleJobSearchMobile = (e: any) => {
        dispatch(setHasMore(true));
        handleSetPageStatus("searching");
        fetchJobMobile(1);
    };

    const handleClearSearchMobile = () => {
        dispatch(setHasMore(true));
        handleSetSearchQuery("");
        fetchJobMobile(1, "");
    }

    const handleOpenChat = () => {
        dispatch(setIsChatting(true));
        dispatch(setIsNewChatFormOtherScreen(true));
        dispatch(setIsScout(false));
        dispatch(setStaffSelected({}));
        dispatch(setChatSelected({id: null, chat_type:"new"}));
        dispatch(setJobSelected({}));
        dispatch(setMessages([]));
        if(chatList.length > 0) {
            dispatch(setIsLoadNewListChat(false));
        }
        navigate('/talent/message')
    }

    const showToast = (title: string, message: string, variant: string, textLink: string = "", clickOnText: any = "") => {
        enqueueSnackbar("I love snacks.", {
            content: (key) => (
                <CustomToast title={title} message={message} variant={variant} textLink={textLink} clickOnText={clickOnText} snackbarKey={key} closeSnackbar={closeSnackbar} />
            ),
        });
    };

    return (
        <>
            {pageStatus === "default" ? (
                <TalentHeader
                    productNameMob="求人"
                    searchInput={true}
                    searchQuery={searchQuery}
                    onSearchChange={handleSetSearchQuery}
                    onSearch={handleJobSearchAll}
                />
            ) : (
                <TalentHeader
                prevPage={{ name: "戻る", onClick: () => handleSetPageStatus("default") }}
                />
            )}
            <div className="pb-[56px] md:pb-0 md:mt-6 md:px-6 flex gap-6 relative">
                <div className="fixed top-56 right-0 z-[99] hidden md:block">
                    <ConsultingButton onClick={handleOpenChat} />
                </div>
                <TalentSideMenu />
                <div className="flex-1 px-4 md:hidden">
                {(suitableJob && suitableJob?.length > 0 && pageStatus === "default") && (
                    <div className="mt-4 md:mt-6">
                        <div className="mb-2 flex items-center justify-between">
                            <h3 className="text-xl font-bold alu-text-base-2">あなたへのおすすめ</h3>
                            { (suitableJobFull && suitableJobTotalResults > maxSuitableJobSlide) ? 
                                <p
                                className="text-sm alu-text-title"
                                onClick={() => suitableJobMore("viewing")}
                                >
                                もっとみる
                                </p> : null
                            }
                        </div>
                        <div style={{ maxWidth: `calc(100vw - ${16 * 2}px)` }}>
                            <CustomCarousel items={carouselList} />
                        </div>
                    </div>
                )}

                {(pageStatus === "viewing") && (
                    <div>
                        <h3 className="mb-2 text-xl font-bold alu-text-base-2">
                            あなたへのおすすめ
                        </h3>
                        {isMobile && (
                        <InfiniteScroll
                            dataLength={suitableJobFull?.length}
                            next={fetchSuitableJob}
                            hasMore={isSuitableJobFullHasMore}
                            loader={isSuitableJobFullHasMore ? <div className="flex justify-center p-2"><LoadingIcon /></div> : null}
                            scrollThreshold={0.5}
                        >
                            <div className="flex flex-col gap-4 pb-6">
                            {suitableJobFull.map((item: any, idx: any) => (
                                <JobCard items={item} key={idx} />
                            ))}
                            </div>
                        </InfiniteScroll>
                        )}
                    </div>
                )}   

                {(pageStatus === "default") && (
                    <div className="mt-4">
                        <h3 className="mb-2 text-xl font-bold alu-text-base-2">
                            {pageStatus === "viewing" ? "あなたへのおすすめ" : "新着求人"}
                        </h3>
                        {isMobile && (
                        <InfiniteScroll
                            dataLength={jobListMobile?.length}
                            next={fetchData}
                            hasMore={hasMore}
                            loader={<div className="flex justify-center p-2"><LoadingIcon /></div>}
                            scrollThreshold={0.5}
                        >
                            <div className="flex flex-col gap-4 pb-6">
                            {jobListMobile.map((item: any, idx: any) => (
                                <JobCard items={item} key={idx} />
                            ))}
                            </div>
                        </InfiniteScroll>
                        )}
                    </div>
                )}

                {pageStatus === "searching" && (
                    <div className="mt-6">
                        <h3 className="mb-2 text-xl font-bold alu-text-base-2">
                            検索結果
                        </h3>
                        <div className="mb-4">
                            <TextInput
                                id="search"
                                name="search"
                                value={searchQuery}
                                onChange={(e: any) => handleSetSearchQuery(e.target.value)}
                                onClearQuery={() => handleClearSearchMobile()}
                                onKeyDown={(e: any) => e.key === "Enter" && handleJobSearchMobile(e)}
                                placeholder="検索"
                                searchIcon={true}
                            />
                        </div>
                        {isMobile && (
                        <InfiniteScroll
                            dataLength={jobListMobile?.length}
                            next={fetchData}
                            hasMore={hasMore}
                            loader={<div className="flex justify-center p-2"><LoadingIcon /></div>}
                            scrollThreshold={0.5}
                        >
                            <div className="flex flex-col gap-4 pb-6">
                            {jobListMobile.map((item: any, idx: any) => (
                                <JobCard items={item} key={idx} />
                            ))}
                            </div>
                        </InfiniteScroll>
                        )}
                    </div>
                )}
                <div className="-mt-6">
                    <Copyright view="talent" />
                </div>
                </div>

                {/* Tablet and Desktop */}
                <div className="hidden md:block md:flex-1">
                    {pageStatus === "searching" && (
                    <div className="mb-6 flex items-center gap-4">
                        <ReturnButton onClick={() => handleSetPageStatus("default")} />
                        <span className="text-sm alu-text-base-1">/</span>
                        <h3 className="text-xl leading-[1.875rem] alu-text-base-2 font-bold">
                            検索結果
                        </h3>
                    </div>
                    )}
                    <div className="mb-8">
                        {pageStatus === "default" && (
                        <h3 className="mb-2 text-xl font-bold alu-text-base-2">
                            求人情報
                        </h3>
                        )}
                        <div className="bg-white rounded-2xl p-4 alu-section-box-shadow">
                            <p className="mb-2 text-sm alu-text-base-2">
                                {formatDate(new Date())}更新 {totalResults}件のタレント求人があります
                            </p>
                            <TextInput
                                id="search"
                                name="search"
                                value={searchQuery}
                                onChange={(e: any) => handleSetSearchQuery(e.target.value)}
                                onClearQuery={() => handleClearSearch()}
                                onKeyDown={(e: any) => e.key === "Enter" && handleJobSearch(e)}
                                placeholder="キーワードや職種、地域で検索できます"
                                searchIcon={true}
                            />
                        </div>
                    </div>

                    {(suitableJob && suitableJob?.length > 0 && pageStatus === "default") && (
                    <div className="mb-8">
                        <div className="mb-4 flex items-center justify-between">
                            <h3
                                className={` text-xl font-bold alu-text-base-2`}
                            >
                                あなたへのおすすめ求人
                            </h3>
                            { (suitableJobFull && suitableJobTotalResults > maxSuitableJobSlide) && 
                                <CustomButton
                                    variant="text"
                                    onClick={suitableJobPCMore}
                                    customStyle="mr-[30px]"
                                >
                                    {isMoreSuitable ? '少なく表示' : 'もっとみる'}
                                </CustomButton>
                            }
                        </div>
                        { !isMoreSuitable && 
                            <div className="flex flex-wrap gap-4 lg:gap-6">
                                {suitableJob.map((item: any, idx: number) => (
                                <div className="w-[230px] lg:w-[280px]" key={idx}>
                                    <JobCard items={item} />
                                </div>
                                ))}
                            </div>
                        }
                        {isMoreSuitable && (Array.isArray(suitableJobPC) && suitableJobPC.length > 0) && (
                            <>
                                <div className="flex flex-wrap gap-4 lg:gap-6">
                                    {suitableJobPC.map((item: any, idx: number) => (
                                    <div className="w-[230px] lg:w-[280px]" key={idx}>
                                        <JobCard items={item} />
                                    </div>
                                    ))}
                                </div>
                                {suitableJobTotalResults > pageSize && (
                                <div className="flex items-center justify-center mb-10 mt-4">
                                    <CustomPagination
                                        total={suitableJobTotalResults}
                                        currentPage={suitableJobCurrentPagePC}
                                        pageSize={pageSize}
                                        onPageChange={handleChangePageSuitable}
                                    />
                                </div>
                                )}
                            </>
                        )}
                    </div>
                    )}

                    <div>
                        <h3
                            className={`${
                                pageStatus === "default" ? "mb-4" : "mb-3"
                            } text-xl font-bold alu-text-base-2`}
                        >
                            {pageStatus === "default" ? "新着求人" : "検索結果"}
                        </h3>
                        {pageStatus === "searching" && (
                        <p className="mb-6 text-sm alu-text-base-2">
                            {countItems}件のタレント求人が見つかりました
                        </p>
                        )}
                        <div className="flex flex-wrap gap-4 lg:gap-6">
                            {jobList.map((item: any, idx: any) => (
                                <div className="w-[230px] lg:w-[280px]" key={idx}>
                                <JobCard items={item} />
                                </div>
                            ))}
                        </div>
                        {countItems > pageSize && (
                        <div className="flex items-center justify-center mt-4">
                            <CustomPagination
                                total={countItems}
                                currentPage={currentPage}
                                pageSize={pageSize}
                                onPageChange={handleChangePage}
                            />
                        </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="hidden md:block">
                <Copyright view="talent" />
            </div>
        </>
    );
};

export default TalentJob;